@if (loading$ | async) {
  <sh-loading [message]="'ui.loading'| translate"></sh-loading>
} @else {
  <ng-content></ng-content>
}
